import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimatedHandComponent } from '@app/shared/ui/animated-hand/animated-hand.component';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { AnimatedHandHartComponent } from './animated-hand-hart.component';
import { AnimatedHandSignComponent } from './animated-hand-sign.component';
import { AnimatedHandMoneyComponent } from './animated-hand-money.component';
import { AnimatedHandSign13MiljoenComponent } from './animated-hand-sign-13miljoen.component';
import { AnimatedHandSignLoveYouComponent } from './animated-hand-sign-loveyou.component';

@NgModule({
    declarations: [
        AnimatedHandComponent,
        AnimatedHandHartComponent,
        AnimatedHandSignComponent,
        AnimatedHandMoneyComponent,
        AnimatedHandSign13MiljoenComponent,
        AnimatedHandSignLoveYouComponent,
    ],
    imports: [
        CommonModule,
        DirectivesModule
    ],
    exports: [
        AnimatedHandComponent,
        AnimatedHandHartComponent,
        AnimatedHandSignComponent,
        AnimatedHandMoneyComponent,
        AnimatedHandSign13MiljoenComponent,
        AnimatedHandSignLoveYouComponent,
    ]
})
export class AnimatedHandModule {
}
